module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/18.923bf370.png";